module.exports = __webpack_public_path__ + "static/NeueHaasUnicaW1G-Medium-e4055635182d0dacc7c7d9819f32b9ba.woff2";